var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isWebCallingEnabled)?_c('call-widget',{on:{"retry":_vm.initializePhone}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }